module.exports = __webpack_public_path__ + "static/media/csrd_banner.cfc5abe8.webp";